// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1h1y6","content":"styles_content__1tR8-"};